import * as R from 'ramda' //we use this instead of Object.keys because it has better types
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as Redux from 'redux'
import * as ReactRedux from 'react-redux'
import {CallJs} from "../lib/types"
import {Input} from "../lib/sbhtml/input";
import {Store} from "react-redux";
import {SingleBox} from "../lib/sbhtml/select";
import {debug, Dispatcher} from "../lib/utils";
import thunkMiddleware from "redux-thunk"

type FieldName = string

type Field = {
	FieldName: FieldName
	Label: string,
	Tab: string,
	Status: boolean,
	Configured: boolean,
	Required: boolean,
	Type: 'Int' | 'Checkbox' | 'Date' | 'Datetime' | 'Money' | 'Number'| 'String'
}

type MembershipTypes = {
	id: string|number
	title: string
	target: string
}

type MembershipStatus = {
	id: string|number
	title: string
}

type WBCCallJs = {
	contactFields: Field[]
	companyFields: Field[]
	membershipTypes: MembershipTypes[]
	membershipStatuses: MembershipStatus[]
	existing: string[]
}

type WBCContactField = 'Id' |
	'PartyType' |
	'Status' |
	'MemberType' |
	'Category' |
	'PrimaryOrganizationId' |
	'NamePrefix' |
	'FirstName' |
	'MiddleName' |
	'LastName' |
	'NameSuffix' |
	'InformalName' |
	'Designation' |
	'BirthDate' |
	'Gender' |
	'PrimaryOrganizationTitle' |
	'OrganizationName' |
	'MobilePhone' |
	'ReceiptPreference'

type WBCAddressField =	'AddressPurpose'|
	'CommunicationReasons'|
	'AddressLine1'|
	'AddressLine2'|
	'AddressLine3'|
	'CityName'|
	'CountrySubEntityCode'|
	'CountrySubEntityName'|
	'CountryCode'|
	'CountryName'|
	'PostalCode'|
	'Email'|
	'Phone'|
	'Fax'

type WBCNameField = 'Website' | 'Status'

type FieldMapping = {
	aoField: FieldName
	literal: string
}

type FieldMappingsOptional<Field extends string> = {
	[index in Field]?: FieldMapping
}
type FieldMappingDefaults<Field extends string> = {
	[index in Field]: FieldMapping & {
		isRelevant: boolean
		editions: ImisEdition[]
	}
}

type ImisEdition = "100"|"300"

type State = {
	version: "one"
	imisEdition : ImisEdition
	recordsRead: number
	recordsPerFile: number
	tabs: TabsState
	membershipTypes: MembershipTypeState
	statuses: MembershipStatusState
	includeArchived: boolean
	includeNotes: boolean
	includeCPD: boolean
	includeConferences: boolean
	includeSegmentation: boolean
	includeSubscriptions: boolean
	includeEvents: boolean
}

type TabsState = {
	Individuals: TabState<WBCContactField | WBCAddressField>
	Organisations: TabState<WBCContactField | WBCAddressField>
	WBCNameP: TabState<WBCNameField>
	WBCNameO: TabState<WBCNameField>
}

type TabsValueProps = {
	Individuals: TabsValueParams<WBCContactField | WBCAddressField>
	Organisations: TabsValueParams<WBCContactField | WBCAddressField>
	WBCNameP: TabsValueParams<WBCNameField>
	WBCNameO: TabsValueParams<WBCNameField>
}

type ValueProps = {
	edition: ImisEdition
	state: State
	recordsRead: string
	recordsPerFile: string
	tabs: TabsValueProps
	membershipTypes: MembershipTypeParams
	statuses: MembershipStatusParams
	includeArchived: boolean
	includeNotes: boolean
	includeCPD: boolean
	includeConferences: boolean
	includeSegmentation: boolean
	includeSubscriptions: boolean
	includeEvents: boolean
	existing: string[]
}

type MembershipTypeParams = {[k: string]: {label: string, target: 'organisation'|'individual', newLabel: string}}
type MembershipTypeState = {[k in string]: string}
type MembershipTypeProps = {[k: string]: {label: string, target: 'organisation'|'individual'}}

type MembershipStatusParams = {[k: string]: {label: string, newLabel: string}}
type MembershipStatusState = {[k in string]: string}

type TabKind = keyof TabsValueProps

type TabState<Field extends string> = {
	isVisible: Boolean
	fieldMap: FieldMappingsOptional<Field>
	focused?: Field
	moused?: Field
}

type TabProps<WBCField extends string> = {
	label: string
	defaultFields: FieldMappingDefaults<WBCField>
	aoFields: Field[]
}

type TabsValueParams<Field extends string> = TabProps<Field> & TabState<Field>

type CallbackProps = {
	submit: (s: State) => void,
	toggleIncludeArchived: () => void,
	toggleIncludeNotes: () => void,
	toggleIncludeCPD: () => void,
	toggleIncludeConferences: () => void,
	toggleIncludeSegmentation: () => void,
	toggleIncludeSubscriptions: () => void,
	toggleIncludeEvents: () => void,
	setMembershipStatus: (serial: string) => (newLabel: string) => void,
	setMembershipType: (serial: string) => (newLabel: string) => void,
	setEdition: (i: ImisEdition) => void,
	setRecordsRead: (i: string) => void,
	setRecordsPerFile: (i: string) => void,
	setField: (field: WBCContactField|WBCAddressField, aoField: FieldName, literal: string, tab: TabKind) => void,
	toggle: (a: TabKind) => void
	focusField: (tab: TabKind, field: WBCContactField|WBCAddressField) => void
	mouseOverField: (tab: TabKind, field: WBCContactField|WBCAddressField) => void
}

type DropDownProps = {
	options: JSX.Element[],
	active: boolean,
	selected: FieldName,
	field: WBCContactField|WBCAddressField,
	aoField: Field,
	onFocus: () => void,
	onMouseOver: () => void,
	onChange: (field: string) => void
}

const DropDown = (props: DropDownProps) =>
	<SingleBox style={{width: "100%" }} onChange={props.onChange} value={props.selected} onFocus={() => props.onFocus()} onKeyDown={() => props.onFocus()} onMouseOver={() => props.onMouseOver()}>
		<option value='' key="string-literal">(fixed string literal)</option>
		{props.active ? props.options : props.aoField.FieldName == "" ? [] : <option key={props.aoField.FieldName} value={props.aoField.FieldName}>{props.aoField.Status ? '* ' : ''}{props.aoField.Label}</option>}
	</SingleBox>

const sortWordsBeforeNumbers = (a: number|string, b: number|string): 0|-1|1 => {
	const aIsNaN = isNaN(+a)
	const bIsNaN = isNaN(+b)

	return aIsNaN && !bIsNaN ? -1 :
	!aIsNaN && bIsNaN ? 1 :
	-1 //todo test this out. i want it to be stable.
	//a < b ? -1 :
	//a > b ? 1 :
	//-1;
}

const keys: <T extends object>(x: T) => (keyof T)[] = R.keys as any

const Display = (props: ValueProps & CallbackProps) => {
	const existing = props.existing && props.existing.length > 0 &&
		<div>
			<p>There are some existing downloads. These are deleted overnight.</p>
			<ul>
				{props.existing.map(e => <li key={e}><a href={"/.uploads/" + e}>{e}</a></li>)}
			</ul>
		</div>

	return <div>
		{existing}

		<p><button onClick={() => {props.submit(props.state); return false}}>Run export</button></p>
		<p>iMIS edition: <SingleBox onChange={(e) => props.setEdition(e == '100' ? '100' : '300')} value={props.edition}>
			<option value='100'>WBC for iMIS 100</option>
			<option value='300'>WBC for iMIS 300</option>
		</SingleBox>
		</p>
		
		<table>
			<tr><td>Include Notes</td><td><input checked={props.includeNotes} onChange={props.toggleIncludeNotes} type="checkbox"/></td></tr>
			<tr><td>Include CPD</td><td><input checked={props.includeCPD} onChange={props.toggleIncludeCPD} type="checkbox"/></td></tr>
			<tr><td>Include Conferences</td><td><input checked={props.includeConferences} onChange={props.toggleIncludeConferences} type="checkbox"/></td></tr>
			<tr><td>Include Segmentation</td><td><input checked={props.includeSegmentation} onChange={props.toggleIncludeSegmentation} type="checkbox"/></td></tr>
			<tr><td>Include Subscriptions</td><td><input checked={props.includeSubscriptions} onChange={props.toggleIncludeSubscriptions} type="checkbox"/></td></tr>
			<tr><td>Include Events</td><td><input checked={props.includeEvents} onChange={props.toggleIncludeEvents} type="checkbox"/></td></tr>
		</table>

		<p>How many records per go? If it doesn't work reduce these numbers.</p>
		<p>Records to hold in memory while generating <Input numeric={{step: 1}} value={props.recordsRead} onChange={props.setRecordsRead} /></p>
		<p>Max records in an xlsx <Input numeric={{step: 1}} value={props.recordsPerFile} onChange={props.setRecordsPerFile} />. If the final file would exceed this, we create separate xlsx files and give you a zip.</p>
		<p>Select the field mapping. We've made a best guess but we can't tell what all the spare fields mean. Consider copying the URL or bookmarking the page once you're set up since we load up from the url.</p>
		<p>Notes.</p>
			<dl>
				<dd>AddressLine1, 2, 3</dd>
				<dt>AO can either store the local part of an address as separate lines or a single blob.
					If you select Address (i.e. a blob) you'll only get the matching line here, so you better select it for all three.
					We've guessed which you want based on which fields are enabled.
				</dt>
			</dl>
		<table>
			<thead style={{fontWeight: "bold"}}>
			<tr>
				<td>AO Membership Status</td>
				<td>WBC Membership Status</td>
			</tr>
			</thead>
			<tbody>
			{keys(props.statuses)
				.sort( sortWordsBeforeNumbers )
				.map(a => <tr key={props.statuses[a].label + "-status"}>
					<td>{props.statuses[a].label}</td>
					<td><Input value={props.statuses[a].newLabel} onChange={props.setMembershipStatus(a)}/></td>
				</tr>)}
			</tbody>
			<tfoot><tr><td>Include Archived?</td><td><input checked={props.includeArchived} onChange={props.toggleIncludeArchived} type="checkbox"/></td></tr></tfoot>
		</table>
		<table>
			<thead style={{fontWeight: "bold"}}>
				<tr>
					<td>AO Membership Type</td>
					<td>WBC Membership Type</td>
					<td>Target</td>
				</tr>
			</thead>
			<tbody>
				{keys(props.membershipTypes)
					.sort( sortWordsBeforeNumbers )
					.map(a => <tr key={props.membershipTypes[a].label + "-key"}>
					<td>{props.membershipTypes[a].label}</td>
					<td><Input value={props.membershipTypes[a].newLabel} onChange={props.setMembershipType(a)}/></td>
					<td>{props.membershipTypes[a].target}</td>
				</tr>)}
			</tbody>
		</table>
		<table>
			<thead>
				<tr>
					<td>WBC field</td>
					<td>AO field label</td>
					<td>AO internal field name</td>
					<td>AO tab</td>
					<td>AO field status</td>
					<td>WBC literal content</td>
				</tr>
			</thead>
			{
				keys(props.tabs).map(tabKind  => {
					const tab = props.tabs[tabKind]

					const options = tab.aoFields.map(f => <option key={f.FieldName} value={f.FieldName}>{f.Status ? '* ' : ''}{f.Label}</option>)

					const defaultFields = tab.defaultFields

					return <tbody key={tabKind}>
						<tr onClick={() => props.toggle(tabKind)}>
							<th style={{background: "#CCCCCC"}} colSpan={6}>{tab.isVisible ? "▼" : "►" } {tab.label}</th>
						</tr>
						{tab.isVisible && keys(defaultFields)
							.filter((a) =>
								tab.defaultFields[a].editions.indexOf(props.edition) >= 0)
							.map((f) => {
							const selected: FieldMapping = tab.fieldMap[f] || Object.assign({isActive: false}, tab.defaultFields[f])
							const details: Field = tab.aoFields.find(a => a.FieldName == selected.aoField) || {
								Label: "(fixed string literal)",
								FieldName: "",
								Tab: '',
								Status: false,
								Configured: false,
								Required: false,
								Type: 'String'
							}

							const activate = () => props.mouseOverField(tabKind, f)

							return <tr style={tab.defaultFields[f].isRelevant ? {background: 'yellow'} : undefined} key={(tab.focused || tab.moused ? "active" : "inactive" )+ f} onMouseOver={activate}>
								<td>{f}</td>
								<td>
									<DropDown selected={selected.aoField}
										options={options}
										active={f == tab.focused || f == tab.moused}
										field={f}
										aoField={details}
										onMouseOver={activate}
										onFocus={() => props.focusField(tabKind, f)}
										onChange={aoField => props.setField(f, aoField, selected.literal, tabKind)}
									/></td>
								<td>{details.FieldName} </td>
								<td>{details.Tab}</td>
								<td>{(details.Required ? 'Required' : (details.Status || !details.FieldName ? '' : 'Disabled'))}</td>
								<td>{selected.aoField === '' ?
									<Input onChange={literal => props.setField(f, '', literal, tabKind)} value={selected.literal} /> : false}</td>
							</tr>
						})}
						</tbody>
					}
				)
			}
		</table>
	</div>
}

type BasicOwnProps = {
	tabs: TabsProps
	membershipTypes: MembershipTypeProps
	statuses: MembershipStatusState
	existing: string[]
}

type OwnProps = BasicOwnProps & {
	store: Store<State>
}

type TabsProps = {
	Individuals: TabProps<WBCContactField|WBCAddressField>
	Organisations: TabProps<WBCContactField|WBCAddressField>
	WBCNameP: TabProps<WBCNameField>
	WBCNameO: TabProps<WBCNameField>
}

type Action = {type: '@@ INIT'} | {type: 'set records read', value: number}
					| {type: 'set records per file', value: number} | FieldMapAction<string>
					| {type: 'inject state', state: {[K in keyof State]?: {}} /* comes from user-supplied json so we tread carefully */}
					| {type: 'toggle visibility', tab: TabKind}
					| {type: 'focus field' | 'mouse over field', tab: TabKind, field: WBCContactField|WBCAddressField}
					| {type: 'set membership type', serial: string, newLabel: string}
	| {type: 'toggle include archived'}
	| {type: 'toggle include notes'}
	| {type: 'toggle include CPD'}
	| {type: 'toggle include conferences'}
	| {type: 'toggle include segmentation'}
	| {type: 'toggle include subscriptions'}
	| {type: 'toggle include events'}
	| {type: 'set edition', edition: ImisEdition}
	| {type: 'set membership status', serial: string, newLabel: string}
type FieldMapAction<Field extends string> = {type: 'set field map', tab: TabKind, fieldMap: FieldMapping, wbcField: Field}

const isActiveEdition = (test: ImisEdition, actives: ImisEdition[]) =>
	actives.indexOf(test) >= 0

const mapDispatchToProps = (dispatch: Dispatcher<Action, State>, ownProps: OwnProps): CallbackProps => ({
	submit: (stateRO: State) => dispatch(() => {
		const form = document.createElement("form")
		form.method = 'POST'

		const transferrableState: State = keys(ownProps.tabs)
			.reduce<State>(
			(state, tab) => reduceTab(tab, state, {fieldMap: Object.assign({}, ownProps.tabs[tab].defaultFields, state.tabs[tab].fieldMap)}),
			JSON.parse(JSON.stringify(stateRO))
		)

		//remove such fields as are irrelevant
		keys(ownProps.tabs).forEach(
			tab =>
				 keys(ownProps.tabs[tab].defaultFields).filter(
					  // field => true // there should be none left
						field => !isActiveEdition(stateRO.imisEdition, ownProps.tabs[tab].defaultFields[field].editions)
				 ).forEach(
					  field => transferrableState.tabs[tab].fieldMap[field] = undefined
				 )
		)

		//note the side-effect
		keys(ownProps.membershipTypes).reduce(
			(types, type) => Object.assign(transferrableState.membershipTypes, {
				[type]: types.hasOwnProperty(type) ? types[type] : ownProps.membershipTypes[type].label
			}),
			transferrableState.membershipTypes
		)

		const stateField = document.createElement('input')
		form.appendChild(stateField)
		stateField.type = "hidden"
		stateField.name = "state"
		stateField.value = JSON.stringify(transferrableState)

		form.style.display = 'none'
		document.body.appendChild(form)
		form.submit()
	}),
	setRecordsRead: (value) => dispatch({type: 'set records read', value: Number.parseInt(value)}),
	setRecordsPerFile: (value) => dispatch({type: 'set records per file', value: Number.parseInt(value)}),
	setField: (wbcField: WBCContactField|WBCAddressField, aoField: FieldName, literal: string, tab: TabKind) => dispatch({type: 'set field map', tab, wbcField, fieldMap: {aoField, literal}}),
	toggle: (tab) => dispatch({type: 'toggle visibility', tab}),
	focusField: (tab, field) => dispatch({type: 'focus field', tab, field}),
	mouseOverField: (tab, field) => dispatch({type: 'mouse over field', tab, field}),
	setMembershipType: (serial: string) => (newLabel: string) => dispatch({type: 'set membership type', serial, newLabel}),
	setMembershipStatus: (serial: string) => (newLabel: string) => dispatch({type: 'set membership status', serial, newLabel}),
	setEdition: (edition: ImisEdition) => dispatch({type: 'set edition', edition}),
	toggleIncludeArchived: () => dispatch({type: 'toggle include archived'}),
	toggleIncludeNotes: () => dispatch({type: 'toggle include notes'}),
	toggleIncludeCPD: () => dispatch({type: 'toggle include CPD'}),
	toggleIncludeConferences: () => dispatch({type: 'toggle include conferences'}),
	toggleIncludeSegmentation: () => dispatch({type: 'toggle include segmentation'}),
	toggleIncludeSubscriptions: () => dispatch({type: 'toggle include subscriptions'}),
	toggleIncludeEvents: () => dispatch({type: 'toggle include events'})
})

const reduceFieldMap = <A extends string>(fieldMap: FieldMappingsOptional<A>, action: FieldMapAction<A>, defaults: FieldMappingDefaults<A>): FieldMappingsOptional<A> => {
	if(defaults[action.wbcField].aoField == action.fieldMap.aoField && defaults[action.wbcField].literal == action.fieldMap.literal) {
		const it = Object.assign({}, fieldMap)
		delete it[action.wbcField]
		return it
	} else {
		return Object.assign({}, fieldMap, {[action.wbcField]: action.fieldMap})
	}
}

const reduceTab = <A extends string>(tab: TabKind, state: State, replace: Partial<TabState<A>>) =>
	({...state,
		tabs: Object.assign({}, state.tabs,
		{[tab]: Object.assign({}, state.tabs[tab], replace)}
		)
	})

const mkReducer = (initialState: State, ownProps: BasicOwnProps) => (s: State = initialState, action: Action): State => {
	const tabs = ownProps.tabs
	const assign = (c: Partial<State>) => Object.assign<{}, State, Partial<State>>({}, s, c)
	switch (action.type) {
		case "set membership status":
			return assign({statuses: Object.assign<MembershipStatusState, MembershipStatusState, MembershipStatusState>(
				{},
					s.statuses,
					{[action.serial]: action.newLabel.slice(0, 5)})})
		case "set membership type":
			return assign({membershipTypes: Object.assign<MembershipTypeState, MembershipTypeState, MembershipTypeState>({}, s.membershipTypes, {[action.serial]: action.newLabel})})
		case "toggle include archived":
			return assign({includeArchived: !s.includeArchived})
		case "toggle include notes":
			return assign({includeNotes: !s.includeNotes})
		case "toggle include CPD":
			return assign({includeCPD: !s.includeCPD})
		case "toggle include conferences":
			return assign({includeConferences: !s.includeConferences})
		case "toggle include segmentation":
			return assign({includeSegmentation: !s.includeSegmentation})
		case "toggle include subscriptions":
			return assign({includeSubscriptions: !s.includeSubscriptions})
		case "toggle include events":
			return assign({includeEvents: !s.includeEvents})
		case "mouse over field":
			return reduceTab(action.tab, s, {moused: action.field})
		case "focus field":
			return reduceTab(action.tab, s, {focused: action.field})
		case "set records per file":
			return assign({recordsPerFile: action.value})
		case "set records read":
			return assign({recordsRead: action.value})
		case "set edition":
			return assign({imisEdition: action.edition})
		case "toggle visibility":
			return reduceTab(action.tab, s, {isVisible: !s.tabs[action.tab].isVisible})
		case "set field map":
			return reduceTab(action.tab, s, {fieldMap: reduceFieldMap(s.tabs[action.tab].fieldMap, action, tabs[action.tab].defaultFields)})
		case "@@ INIT":
			return initialState
		case "inject state":
			const recordsPerFile: number = action.state.hasOwnProperty('recordsPerFile') && typeof action.state['recordsPerFile'] == 'number' ? action.state['recordsPerFile'] as number : initialState.recordsPerFile
			const recordsRead: number = action.state.hasOwnProperty('recordsRead') && typeof action.state['recordsRead'] == 'number' ? action.state['recordsRead'] as number : initialState.recordsRead

			let statuses: MembershipStatusState = {}
			if(action.state.hasOwnProperty('statuses') && typeof  action.state.statuses == 'object') {
				const stateStatuses: MembershipStatusState = action.state.statuses
				statuses = keys(stateStatuses).reduce<MembershipStatusState>((acc, k: keyof typeof stateStatuses) => {
					// noinspection SuspiciousTypeOfGuard who knows what it looks like
					if (stateStatuses.hasOwnProperty(k) && typeof stateStatuses[k] == 'string' ) {
						return Object.assign<MembershipStatusState, MembershipStatusState>(acc, {[k]: stateStatuses[k]})
					} else {
						return acc
					}
				}, {})
			}

			let membershipTypes: MembershipTypeState = {}
			if(action.state.hasOwnProperty('membershipTypes') && typeof  action.state.membershipTypes == 'object') {
				const stateTypes: MembershipTypeState = action.state.membershipTypes
				membershipTypes = keys(stateTypes).reduce<MembershipTypeState>((acc, k: keyof typeof stateTypes) => {
							// noinspection SuspiciousTypeOfGuard who knows what it looks like
							if (stateTypes.hasOwnProperty(k) && typeof stateTypes[k] == 'string' ) {
								return Object.assign<MembershipTypeState, MembershipTypeState>(acc, {[k]: stateTypes[k]})
							} else {
								return acc
							}
						}, {})
			}

			const edition = action.state.hasOwnProperty('imisEdition') && action.state.imisEdition == '100' ? '100' : '300'
			const includeArchived = action.state.hasOwnProperty('includeArchived') ? !!action.state.includeArchived : false
			const includeNotes = action.state.hasOwnProperty('includeNotes') ? !!action.state.includeNotes : true
			const includeCPD = action.state.hasOwnProperty('includeCPD') ? !!action.state.includeCPD : true
			const includeConferences = action.state.hasOwnProperty('includeConferences') ? !!action.state.includeConferences : true
			const includeSegmentation = action.state.hasOwnProperty('includeSegmentation') ? !!action.state.includeSegmentation : true
			const includeSubscriptions = action.state.hasOwnProperty('includeSubscriptions') ? !!action.state.includeSubscriptions : true
			const includeEvents = action.state.hasOwnProperty('includeEvents') ? !!action.state.includeEvents : true

			let newState: State = {
				version: "one",
				imisEdition: edition,
				includeArchived,
				includeNotes,
				includeCPD,
				includeConferences,
				includeSegmentation,
				includeSubscriptions,
				includeEvents,
				recordsPerFile,
				recordsRead,
				membershipTypes,
				statuses,
				tabs: {
					Individuals: {
						isVisible: true,
						fieldMap: {}
					},
					Organisations: {
						isVisible: true,
						fieldMap: {}
					},
					WBCNameO: {
						isVisible: true,
						fieldMap: {}
					},
					WBCNameP: {
						isVisible: true,
						fieldMap: {}
					}
				}
			}

			//the intention is that all the casting here should be perfectly valid because
			//(a) we cast it to something that is generic and therefore will require us to check it before we use it
			//(b) we are casting to tell typescript to shut up in the case that is identifying code as an error since it's partially redundant
			//    (for instance, we're passing an array of {} to something that's meant to take a subset of {}, but it's safe because it will
			//    simply return false in the extra cases and therefore there's technically no type error)
			//i advise you not to trust me willy nilly.

			const state = action.state
			if (state.hasOwnProperty('tabs') && typeof state.tabs == 'object') {
				const stateTabs = action.state.tabs as {[T in TabKind]? : {}}
				keys(tabs).map((tabName) => {
					if (stateTabs.hasOwnProperty(tabName) && typeof stateTabs[tabName] == 'object' && stateTabs[tabName]) {
						const stateTab = stateTabs[tabName] as {[T in keyof TabState<string>]? : {}}|undefined
						if (stateTab && stateTab.hasOwnProperty('fieldMap') && typeof stateTab.fieldMap == 'object') {
							const newFields: { [index: string]: FieldMapping } = stateTab.fieldMap
							for (const wbcField in newFields) {
								const field = newFields[wbcField]
								if (tabs[tabName].defaultFields.hasOwnProperty(wbcField)
									&& field.hasOwnProperty('aoField') && (field.aoField === '' || tabs[tabName].aoFields.find(a => a.FieldName == field.aoField))
									&& field.hasOwnProperty('literal') && typeof field.literal == 'string') {
									const literal: string = field.literal as string //verified in the if
									const aoField: string = field.aoField as string // verified in the if - either branch confirms it's a string, since '' is a string and if it's in array of strings, it must be a string

									const action: FieldMapAction<string /*note that we defacto verify the subtype by checking that we're in the defaults*/> = {
										type: 'set field map',
										wbcField: wbcField,
										fieldMap: {literal, aoField},
										tab: tabName
									}

									newState = reduceTab(tabName, newState, {fieldMap: reduceFieldMap(newState.tabs[tabName].fieldMap, action, tabs[tabName].defaultFields)})
								}
							}
						}
					}
				})
			}

			return newState
	}
}

export const runPage: CallJs<WBCCallJs> = (cb, params) => {
	const div = document.createElement('div')
	cb(div)

	const addressEnabled = params.contactFields
		.filter(a => a.FieldName === 'Address')
		.reduce((acc, it) => acc || it.Status, false)

	const companyAddressEnabled = params.companyFields
		.filter(a => a.FieldName === 'CompanyAddress')
		.reduce((acc, it) => acc || it.Status, false)

	const defaultContactsFields: FieldMappingDefaults<WBCContactField|WBCAddressField> = {
		Id: { aoField: 'UserId', literal: '', isRelevant: true, editions: ['100', '300']},
		PartyType: { aoField: '', literal: 'P', isRelevant: true, editions: ['100', '300']},
		Status: { aoField: 'special:Archival Status', literal: '', isRelevant: true, editions: ['100', '300']},
		Category: { aoField: 'special:Category Title', literal: '', isRelevant: true, editions: ['300']},
		MemberType: { aoField: 'special:Membership Type', literal: '', isRelevant: true, editions: ['300']},
		PrimaryOrganizationId: { aoField: 'CompanyId', literal: '', isRelevant: true, editions: ['100', '300']},
		NamePrefix: { aoField: 'Title', literal: '', isRelevant: true, editions: ['100', '300']},
		FirstName: { aoField: 'FirstName', literal: '', isRelevant: true, editions: ['100', '300']},
		MiddleName: { aoField: '', literal: '', isRelevant: true, editions: ['100', '300']},
		LastName: { aoField: 'LastName', literal: '', isRelevant: true, editions: ['100', '300']},
		InformalName: { aoField: 'FirstName', literal: '', isRelevant: true, editions: ['100', '300']},
		NameSuffix: { aoField: '', literal: '', isRelevant: true, editions: ['100', '300']},
		Designation: { aoField: '', literal: '', isRelevant: true, editions: ['100', '300']},
		BirthDate: { aoField: 'BirthDate', literal: '', isRelevant: true, editions: ['100', '300']},
		Gender: { aoField: 'Gender', literal: '', isRelevant: true, editions: ['100', '300']},
		PrimaryOrganizationTitle: { aoField: '', literal: '', isRelevant: true, editions: ['100', '300']},
		OrganizationName: {aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
		MobilePhone: { aoField: 'Mobile', literal: '', isRelevant: true, editions: ['100', '300']},

		AddressPurpose: {aoField: '', literal: 'Street', isRelevant: true, editions: ['100', '300']},
		CommunicationReasons: {aoField: '', literal: 'default', isRelevant: true, editions: ['100', '300']},
		AddressLine1: {aoField: addressEnabled ? 'Address' : 'AddressLine1', literal: '', isRelevant: true, editions: ['100', '300']},
		AddressLine2: {aoField: addressEnabled ? 'Address' : 'AddressLine2', literal: '', isRelevant: true, editions: ['100', '300']},
		AddressLine3: {aoField: addressEnabled ? 'Address' : 'AddressLine3', literal: '', isRelevant: true, editions: ['100', '300']},
		CityName: {aoField: 'City', literal: '', isRelevant: true, editions: ['100', '300']},
		CountrySubEntityCode: {aoField: 'State', literal: '', isRelevant: true, editions: ['100', '300']},
		CountrySubEntityName: {aoField: 'State', literal: '', isRelevant: true, editions: ['100', '300']},
		CountryCode: {aoField: '', literal: '', isRelevant: true, editions: ['100', '300']},
		CountryName: {aoField: 'Country', literal: '', isRelevant: true, editions: ['100', '300']},
		PostalCode: {aoField: 'Postcode', literal: '', isRelevant: true, editions: ['100', '300']},
		Email: {aoField: 'Email1', literal: '', isRelevant: true, editions: ['100', '300']},
		Phone: {aoField: 'Phone', literal: '', isRelevant: true, editions: ['100', '300']},
		Fax: {aoField: 'Fax', literal: '', isRelevant: true, editions: ['100', '300']},

		ReceiptPreference: {aoField: '', literal: '', isRelevant: true, editions: ['100']},
	}
	const defaultCompanyFields: FieldMappingDefaults<WBCContactField|WBCAddressField> = {
			Id: { aoField: 'UserId', literal: '', isRelevant: true, editions: ['100', "300"]},
			PartyType: { aoField: '', literal: 'O', isRelevant: true, editions: ['100', '300']},
			Status: { aoField: 'special:Archival Status', literal: '', isRelevant: true, editions: ['100', '300']},
		Category: { aoField: 'special:Category Title', literal: '', isRelevant: true, editions: ['300']},
		MemberType: { aoField: 'special:Membership Type', literal: '', isRelevant: true, editions: ['300']},
			PrimaryOrganizationId: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			NamePrefix: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			FirstName: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			MiddleName: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			LastName: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			InformalName: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			NameSuffix: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			Designation: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			BirthDate: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			Gender: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			PrimaryOrganizationTitle: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300']},
			OrganizationName: {aoField: 'Company', literal: '', isRelevant: true, editions: ['100', '300']},
			MobilePhone: { aoField: 'CompanyPhone', literal: '', isRelevant: true, editions: ['100', '300']},

		AddressPurpose: {aoField: '', literal: 'Street', isRelevant: true, editions: ['100', '300']},
		CommunicationReasons: {aoField: '', literal: 'default', isRelevant: true, editions: ['100', '300']},
		AddressLine1: {aoField: companyAddressEnabled ? 'CompanyAddress' : 'CompanyAddressLine1', literal: '', isRelevant: true, editions: ['100', '300']},
		AddressLine2: {aoField: companyAddressEnabled ? 'CompanyAddress' : 'CompanyAddressLine2', literal: '', isRelevant: true, editions: ['100', '300']},
		AddressLine3: {aoField: companyAddressEnabled ? 'CompanyAddress' : 'CompanyAddressLine3', literal: '', isRelevant: true, editions: ['100', '300']},
		CityName: {aoField: 'CompanyCity', literal: '', isRelevant: true, editions: ['100', '300']},
		CountrySubEntityCode: {aoField: 'CompanyState', literal: '', isRelevant: true, editions: ['100', '300']},
		CountrySubEntityName: {aoField: 'CompanyState', literal: '', isRelevant: true, editions: ['100', '300']},
		CountryCode: {aoField: '', literal: '', isRelevant: true, editions: ['100', '300']},
		CountryName: {aoField: 'CompanyCountry', literal: '', isRelevant: true, editions: ['100', '300']},
		PostalCode: {aoField: 'CompanyPostcode', literal: '', isRelevant: true, editions: ['100', '300']},
		Email: {aoField: 'CompanyEmail1', literal: '', isRelevant: true, editions: ['100', '300']},
		Phone: {aoField: 'CompanyPhone', literal: '', isRelevant: true, editions: ['100', '300']},
		Fax: {aoField: 'CompanyFax', literal: '', isRelevant: true, editions: ['100', '300']},
		ReceiptPreference: { aoField: '', literal: '', isRelevant: false, editions: ['100']},
	}

	const defaultWbcNameFields: FieldMappingDefaults<WBCNameField> = {
		Website: {aoField: 'Web', literal: '', isRelevant: true, editions: ['100', '300']},
		Status: {aoField: '', literal: 'I', isRelevant: true, editions: ['300']},
	}
	const defaultWbcNameOFields: FieldMappingDefaults<WBCNameField> = {
		Website: {aoField: 'CompanyWeb', literal: '', isRelevant: true, editions: ['100', '300']},
		Status: {aoField: '', literal: 'I', isRelevant: true, editions: ['300']},
	}

	const initialState: State = {
		version: "one",
		includeArchived: false,
		includeNotes: true,
		includeCPD: true,
		includeConferences: true,
		includeSegmentation: true,
		includeSubscriptions: true,
		includeEvents: true,
		imisEdition: "300",
		tabs: {
			Individuals: {isVisible: true, fieldMap: {}},
			Organisations: {isVisible: true, fieldMap: {}},
			WBCNameP: {isVisible: true, fieldMap: {}},
			WBCNameO: {isVisible: true, fieldMap: {}}
		},
		recordsRead: 1000,
		recordsPerFile: 10000,
		membershipTypes: {"contact": "", "company": ""},
		statuses: {"1": "A", "2": "L"}
	}

	const tabsProps: TabsProps = {
		Individuals: {
			label: "Individuals",
			defaultFields: defaultContactsFields,
			aoFields: params.contactFields
		},
		Organisations: {
			label: "Organisations",
			defaultFields: defaultCompanyFields,
			aoFields: params.companyFields
		},
		WBCNameP: {
			label: "WBC_Name (Individual memberships)",
			defaultFields: defaultWbcNameFields,
			aoFields: params.contactFields
		},
		WBCNameO: {
			label: "WBC_Name (Organisational memberships)",
			defaultFields: defaultWbcNameOFields,
			aoFields: params.companyFields
		}
	}

	const membershipTypes = params.membershipTypes
		.reduce<MembershipTypeProps>(
			(acc, me) => Object.assign<MembershipTypeProps, MembershipTypeProps>(acc, {[me.id]: {label: me.title, target: me.target == 'organisation' ? 'organisation' : 'individual'}}),
			{
				"contact": {label: "(contacts without memberships)", target: 'individual'},
				"company": {label: "(companies without memberships but with exported members)", target: 'organisation'},
			})

	const addStatusToStatuses = (acc: MembershipStatusState, me: MembershipStatus): MembershipStatusState => Object.assign<MembershipStatusState, MembershipStatusState>(acc, {[`${me.id}`]: me.title})
	const existing = params.existing.filter(e => e.endsWith('.zip'))
	const ownProps: BasicOwnProps = {
		tabs: tabsProps,
		membershipTypes,
		statuses: params.membershipStatuses.reduce(addStatusToStatuses, {}),
		existing
	}

	const store = Redux.createStore(mkReducer(initialState, ownProps), initialState, Redux.applyMiddleware(thunkMiddleware))

	const mapStateToProps = (s: State = initialState, ownProps: OwnProps): ValueProps => ({
		existing: ownProps.existing,
		edition: s.imisEdition,
		recordsRead: s.recordsRead + "",
		recordsPerFile: s.recordsPerFile + "",
		state: s,
		includeArchived: s.includeArchived,
		includeNotes: s.includeNotes,
		includeCPD: s.includeCPD,
		includeConferences: s.includeConferences,
		includeSubscriptions: s.includeSubscriptions,
		includeSegmentation: s.includeSegmentation,
		includeEvents: s.includeEvents,
		tabs: {
			Individuals: Object.assign({}, ownProps.tabs.Individuals, s.tabs.Individuals),
			Organisations: Object.assign({}, ownProps.tabs.Organisations, s.tabs.Organisations),
			WBCNameP: Object.assign({}, ownProps.tabs.WBCNameP, s.tabs.WBCNameP),
			WBCNameO: Object.assign({}, ownProps.tabs.WBCNameO, s.tabs.WBCNameO),
		},
		membershipTypes: keys(ownProps.membershipTypes).reduce<MembershipTypeParams>(
			(acc, key) => Object.assign<MembershipTypeParams, MembershipTypeParams>(acc, {[key]: {
					label: ownProps.membershipTypes[key].label,
					target: ownProps.membershipTypes[key].target,
					newLabel: s.membershipTypes.hasOwnProperty(key) ? s.membershipTypes[key] : ownProps.membershipTypes[key].label
				}}),
			{}
		),
		statuses: keys(ownProps.statuses).reduce<MembershipStatusParams>( // todo some kind of indexwise zip
			(acc, key) => Object.assign<MembershipStatusParams, MembershipStatusParams>(acc, {[key]: {
				label: ownProps.statuses[key],
				newLabel: s.statuses.hasOwnProperty(key) ? s.statuses[key] : ''
			}}),
			{}
		)
	})

	store.subscribe(() => {
		const state = JSON.stringify(store.getState())
		if(state !== window.location.hash) {
			window.location.hash = state
		}
	})

	const loadFromUri = () => {
		const hash = decodeURIComponent(window.location.hash.slice(1).replace('+', '%20'))
		try {
			const state = JSON.stringify(store.getState())
			if (hash !== state) {
				store.dispatch({type: 'inject state', state: JSON.parse(hash)})
			}
		} catch {
		}
	}

	loadFromUri()

	window.addEventListener('hashchange', loadFromUri)

	const App = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Display)

	ReactDOM.render(<App {...ownProps} store={store} />, div)
}




// WEBPACK FOOTER //
// ./src/controlcentre/wbc-export.tsx